import { render, staticRenderFns } from "./AssistantDraftCard.vue?vue&type=template&id=a6fa8afa&scoped=true"
import script from "./AssistantDraftCard.vue?vue&type=script&lang=js"
export * from "./AssistantDraftCard.vue?vue&type=script&lang=js"
import style0 from "./AssistantDraftCard.vue?vue&type=style&index=0&id=a6fa8afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fa8afa",
  null
  
)

export default component.exports